import { AppActionType } from './action-types';
import { SystemEnvironment } from '@/constants/systemEnviroment';

export const setEnvironment = (environment: SystemEnvironment) => {
  return {
    type: AppActionType.SET_ENVIRONMENT,
    payload: { environment },
  };
};

export type AppAction = ReturnType<typeof setEnvironment>;
